<template>
    <div class="chat-user-carousel-item-root">
        <div class="chat-button-wrapper clickable" @click="onClick">
            <div class="chat-button" :style="!avatar ? 'background-color: var(--primary)' : ''">
                <div
                    :style="{
                        backgroundImage: 'url(\'' + avatar + '/small.jpg\')',
                    }"
                    class="avatar"
                    v-b-tooltip.hover.top.html="getTooltipData()"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import AnalyticService from '../../../services/AnalyticService';

export default {
    name: 'ChatUserCarouselItem',
    props: {
        displayName: String,
        avatar: String,
        id: String,
        title: String,
        companyId: Number,
        companyTitle: String,
    },
    data() {
        return {
            clicked: false,
        };
    },
    methods: {
        onClick() {
            if (!this.clicked) {
                AnalyticService.chatStartEvent(this.companyId, this.companyTitle);
            }
            this.clicked = true;
            this.$emit('click');
        },
        firstLetterOfName() {
            let { displayName } = this;
            return displayName ? displayName[0] : 'A';
        },
        getTooltipData() {
            let title = '<strong>' + this.title + '</strong>';

            return {
                title:
                    "<div style='text-align: center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;'>" +
                    this.displayName +
                    '<br />' +
                    title +
                    '</div>',
            };
        },
    },
};
</script>

<style lang="css" scoped>
.chat-user-carousel-item-root {
    width:50px;
    margin:auto;
}
.chat-button-wrapper {
    height: 60px;
    width: 60px;
}
.chat-button {
    width: 100%;
    height: 100%;
    font-size: 100%;
    border-radius: 50%;
    box-shadow: var(--shadow);
    overflow: hidden;
    border:3px solid #00ca49;
}
.avatar {
    width: 100%;
    height: 100%;
    background: no-repeat center center;
    background-size: cover;
}
</style>
